function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#ACB3BE",
  fillRule: "evenodd",
  d: "M18.5,8.9 L16.9,7.3 C16.6,7 16.1,6.8 15.6,6.8 L14,6.8 L14,4.9 C14,4.4 13.6,4 13.1,4 L1.9,4 C1.4,4 1,4.4 1,4.9 L1,14.3 C1,15.5 2,16.5 3.2,16.5 C3.9,16.5 4.6,16.1 5,15.6 C5.4,16.2 6.1,16.5 6.8,16.5 C8,16.5 9,15.5 9,14.3 C9,14.1 9,14 9,13.9 L13.6,13.9 L13.6,14.3 C13.6,15.5 14.6,16.5 15.8,16.5 C17,16.5 18,15.5 18,14.3 C18,14.1 18,14 18,13.9 L18.5,13.9 C18.7,13.9 19,13.7 19,13.4 L19,10.1 C19,9.7 18.8,9.2 18.5,8.9 Z M3.2,15.7 C2.5,15.7 1.9,15.1 1.9,14.3 C1.9,13.6 2.5,13 3.2,13 C3.9,13 4.5,13.6 4.5,14.3 C4.6,15.1 4,15.7 3.2,15.7 Z M6.8,15.7 C6.1,15.7 5.5,15.1 5.5,14.3 C5.5,13.6 6.1,13 6.8,13 C7.5,13 8.2,13.6 8.2,14.3 C8.2,15.1 7.6,15.7 6.8,15.7 Z M15.8,15.7 C15.1,15.7 14.5,15.1 14.5,14.3 C14.5,13.6 15.1,13 15.8,13 C16.5,13 17.2,13.6 17.2,14.3 C17.2,15.1 16.6,15.7 15.8,15.7 Z M14,9.4 L14,7.6 L15.5,7.6 C15.7,7.6 16,7.7 16.1,7.9 L17.6,9.4 L14,9.4 Z"
});

var SvgTruck = function SvgTruck(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTruck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/truck.3a4bf7ab.svg";
export { ForwardRef as ReactComponent };